
<div class="container animated fadeIn">
  <div class="title">
    <h1 *ngIf="heroes.length > 0; else noHeroesfound"><span class="term">{{ term }}</span> results:</h1>
    <ng-template #noHeroesfound><h1>The hero <span class="term">{{ term }}</span> was not found.</h1></ng-template>
    <small>Super heroes from Marvel and DC Comics.</small>
  </div>

  <div class="heroes" *ngIf="heroes.length > 0">

    <app-hero-card [hero]="superHero" *ngFor="let superHero of heroes"></app-hero-card>

  </div>

  <div class="heroesNotFound" *ngIf="heroes.length === 0">
    <img src="/assets/hero-not-found.svg" alt="">
  </div>

</div>